/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../bills/employee';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_member_attribution": {
        "nested": {
          "TipPeriod": {
            "values": {
              "DO_NOT_USE_TIP_PERIOD": 0,
              "WORKDAY": 1,
              "WORKWEEK": 2
            }
          },
          "JobPercentage": {
            "fields": {
              "jobToken": {
                "type": "string",
                "id": 1,
                "rule": "required"
              },
              "percentage": {
                "type": "int32",
                "id": 2,
                "rule": "required"
              }
            }
          },
          "JobPoint": {
            "fields": {
              "jobToken": {
                "type": "string",
                "id": 1,
                "rule": "required"
              },
              "point": {
                "type": "int32",
                "id": 2,
                "rule": "required"
              }
            }
          },
          "JobPercentageSettings": {
            "fields": {
              "jobPercentages": {
                "type": ".squareup.team_member_attribution.JobPercentage",
                "id": 1,
                "rule": "repeated"
              },
              "splitMethod": {
                "type": ".squareup.team_member_attribution.JobPercentageSettings.SplitMethod",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "SplitMethod": {
                "values": {
                  "DO_NOT_USE_SPLIT_METHOD": 0,
                  "HOURS_WORKED": 1,
                  "EVENLY": 2
                }
              }
            }
          },
          "JobPointSettings": {
            "fields": {
              "jobPoints": {
                "type": ".squareup.team_member_attribution.JobPoint",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "TeamMemberAttributionDetails": {
            "nested": {
              "TipDistributionMethod": {
                "values": {
                  "UNKNOWN": 0,
                  "DIRECT": 1,
                  "POOLED": 2,
                  "POOLED_BY_WORKDAY": 3,
                  "POOLED_BY_HOURS": 4
                }
              }
            }
          },
          "CommissionSettings": {
            "fields": {
              "servicesDeductFromSale": {
                "type": ".squareup.team_member_attribution.DeductFromSale",
                "id": 1,
                "rule": "optional"
              },
              "itemsDeductFromSale": {
                "type": ".squareup.team_member_attribution.DeductFromSale",
                "id": 2,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "merchantCommissionSettings": {
                "type": ".squareup.team_member_attribution.MerchantCommissionSettings",
                "id": 4,
                "rule": "repeated"
              },
              "teamMemberCommissionSettings": {
                "type": ".squareup.team_member_attribution.TeamMemberCommissionSettings",
                "id": 5,
                "rule": "repeated"
              }
            }
          },
          "DeductFromSale": {
            "fields": {
              "deductDiscounts": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "deductProcessingFees": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "deductTaxes": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "deductServiceCost": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "MerchantCommissionSettings": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "itemizationItemType": {
                "type": ".squareup.team_member_attribution.MerchantCommissionSettings.ItemizationItemType",
                "id": 2,
                "rule": "optional"
              },
              "strategy": {
                "type": ".squareup.team_member_attribution.MerchantCommissionSettings.Strategy",
                "id": 3,
                "rule": "optional"
              },
              "tierPer": {
                "type": ".squareup.team_member_attribution.MerchantCommissionSettings.TierPer",
                "id": 4,
                "rule": "optional"
              },
              "tierThresholds": {
                "type": "string",
                "id": 5,
                "rule": "repeated"
              },
              "effectiveFrom": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "tierCadence": {
                "type": ".squareup.team_member_attribution.MerchantCommissionSettings.TierCadence",
                "id": 7,
                "rule": "optional"
              },
              "deductDiscounts": {
                "type": "bool",
                "id": 8,
                "rule": "optional"
              },
              "deductProcessingFees": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "deductTaxes": {
                "type": "bool",
                "id": 10,
                "rule": "optional"
              },
              "deductServiceCost": {
                "type": "bool",
                "id": 11,
                "rule": "optional"
              }
            },
            "nested": {
              "ItemizationItemType": {
                "values": {
                  "REGULAR": 1,
                  "APPOINTMENTS_SERVICE": 2
                }
              },
              "Strategy": {
                "values": {
                  "NONE": 1,
                  "FLAT": 2,
                  "TIERED": 3
                }
              },
              "TierPer": {
                "values": {
                  "QUANTITY": 1,
                  "CENTS": 2
                }
              },
              "TierCadence": {
                "values": {
                  "WEEKLY": 1,
                  "BI_WEEKLY": 2,
                  "SEMI_MONTHLY": 3,
                  "MONTHLY": 4,
                  "QUARTERLY": 5
                }
              }
            }
          },
          "TeamMemberCommissionSettings": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "employeeToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "servicesTierBasisPoints": {
                "type": "uint64",
                "id": 3,
                "rule": "repeated"
              },
              "itemsTierBasisPoints": {
                "type": "uint64",
                "id": 4,
                "rule": "repeated"
              },
              "servicesCommissionBasisPoints": {
                "type": "string",
                "id": 5,
                "rule": "repeated"
              },
              "itemsCommissionBasisPoints": {
                "type": "string",
                "id": 6,
                "rule": "repeated"
              }
            }
          },
          "UnitTipDistributionSetting": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "effectiveFrom": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "method": {
                "type": ".squareup.team_member_attribution.UnitTipDistributionSetting.TipDistributionMethod",
                "id": 3,
                "rule": "optional"
              },
              "useWorkdayFallback": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "tipPeriod": {
                "type": ".squareup.team_member_attribution.TipPeriod",
                "id": 5,
                "rule": "optional"
              },
              "jobPercentageSettings": {
                "type": ".squareup.team_member_attribution.JobPercentageSettings",
                "id": 6
              },
              "jobPointSettings": {
                "type": ".squareup.team_member_attribution.JobPointSettings",
                "id": 7
              }
            },
            "nested": {
              "TipDistributionMethod": {
                "values": {
                  "DO_NOT_USE": 0,
                  "DIRECT": 1,
                  "POOLED": 2,
                  "POOLED_BY_HOURS": 3,
                  "POOLED_BY_PERCENTAGE": 4
                }
              },
              "extra_settings": {
                "oneof": ["jobPercentageSettings", "jobPointSettings"]
              }
            }
          },
          "TipDistributionSettingsUpdate": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "locationIds": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "previousTipDistributionMethod": {
                "type": ".squareup.team_member_attribution.UnitTipDistributionSetting.TipDistributionMethod",
                "id": 3,
                "rule": "optional"
              },
              "previousTipPeriod": {
                "type": ".squareup.team_member_attribution.TipPeriod",
                "id": 4,
                "rule": "optional"
              },
              "previousUseWorkdayFallback": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "previousLocalEffectiveFrom": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "newTipDistributionMethod": {
                "type": ".squareup.team_member_attribution.UnitTipDistributionSetting.TipDistributionMethod",
                "id": 7,
                "rule": "optional"
              },
              "newTipPeriod": {
                "type": ".squareup.team_member_attribution.TipPeriod",
                "id": 8,
                "rule": "optional"
              },
              "newUseWorkdayFallback": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "newLocalEffectiveFrom": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "previousTipDistributionSetting": {
                "type": ".squareup.team_member_attribution.TipDistributionSettingsUpdate.TipDistributionSetting",
                "id": 11,
                "rule": "optional"
              },
              "newTipDistributionSetting": {
                "type": ".squareup.team_member_attribution.TipDistributionSettingsUpdate.TipDistributionSetting",
                "id": 12,
                "rule": "optional"
              }
            },
            "nested": {
              "TipDistributionSetting": {
                "fields": {
                  "tipDistributionMethod": {
                    "type": ".squareup.team_member_attribution.UnitTipDistributionSetting.TipDistributionMethod",
                    "id": 1,
                    "rule": "optional"
                  },
                  "useWorkdayFallback": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tipPeriod": {
                    "type": ".squareup.team_member_attribution.TipPeriod",
                    "id": 3,
                    "rule": "optional"
                  },
                  "localEffectiveFrom": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "jobPercentageSettings": {
                    "type": ".squareup.team_member_attribution.JobPercentageSettings",
                    "id": 5
                  },
                  "jobPointSettings": {
                    "type": ".squareup.team_member_attribution.JobPointSettings",
                    "id": 6
                  }
                },
                "nested": {
                  "extra_settings": {
                    "oneof": ["jobPercentageSettings", "jobPointSettings"]
                  }
                }
              }
            }
          },
          "DirectTip": {
            "fields": {
              "tip": {
                "type": ".squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "minute": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "teamMemberId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "locationId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "WorkweekTips": {
            "fields": {
              "locationId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "workweekStart": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "workweekEnd": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "periodStart": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "periodEnd": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "teamMemberTips": {
                "type": ".squareup.team_member_attribution.WorkweekTips.TeamMemberTip",
                "id": 6,
                "rule": "repeated"
              }
            },
            "nested": {
              "TeamMemberTip": {
                "fields": {
                  "tip": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "LaterTipRefund": {
            "fields": {
              "takenAt": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "tip": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "teamMemberId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "locationId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "TipAttributionDetails": {
            "fields": {
              "employee": {
                "type": ".squareup.bills.Employee",
                "id": 1,
                "rule": "optional"
              },
              "tipMoney": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "timecardToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_member_attribution?.nested?.TipPeriod && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.JobPercentage && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.JobPoint && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.JobPercentageSettings && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.JobPercentageSettings?.nested?.SplitMethod && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.JobPointSettings && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.TeamMemberAttributionDetails?.nested?.TipDistributionMethod && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.CommissionSettings && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.DeductFromSale && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.MerchantCommissionSettings && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.MerchantCommissionSettings?.nested?.ItemizationItemType && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.MerchantCommissionSettings?.nested?.Strategy && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.MerchantCommissionSettings?.nested?.TierPer && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.MerchantCommissionSettings?.nested?.TierCadence && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.TeamMemberCommissionSettings && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.UnitTipDistributionSetting && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.UnitTipDistributionSetting?.nested?.TipDistributionMethod && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.TipDistributionSettingsUpdate && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.TipDistributionSettingsUpdate?.nested?.TipDistributionSetting && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.DirectTip && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.WorkweekTips && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.WorkweekTips?.nested?.TeamMemberTip && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.LaterTipRefund && !$root.nested?.squareup?.nested?.team_member_attribution?.nested?.TipAttributionDetails) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TipPeriod @ squareup/team_member_attribution/model.proto at 14:1
 */
export const TipPeriod = $root.lookupEnum('squareup.team_member_attribution.TipPeriod').values;
/**
 * SOURCE JobPercentage @ squareup/team_member_attribution/model.proto at 21:1
 */
export const JobPercentage = $root.lookupType('squareup.team_member_attribution.JobPercentage');
fixType(JobPercentage);
Builder.createAndAttachToType(JobPercentage);
/**
 * SOURCE JobPoint @ squareup/team_member_attribution/model.proto at 26:1
 */
export const JobPoint = $root.lookupType('squareup.team_member_attribution.JobPoint');
fixType(JobPoint);
Builder.createAndAttachToType(JobPoint);
/**
 * SOURCE JobPercentageSettings @ squareup/team_member_attribution/model.proto at 31:1
 */
export const JobPercentageSettings = $root.lookupType('squareup.team_member_attribution.JobPercentageSettings');
fixType(JobPercentageSettings);
Builder.createAndAttachToType(JobPercentageSettings);
/**
 * SOURCE SplitMethod @ squareup/team_member_attribution/model.proto at 32:3
 */
JobPercentageSettings.SplitMethod = $root.lookupEnum('squareup.team_member_attribution.JobPercentageSettings.SplitMethod').values;
/**
 * SOURCE JobPointSettings @ squareup/team_member_attribution/model.proto at 41:1
 */
export const JobPointSettings = $root.lookupType('squareup.team_member_attribution.JobPointSettings');
fixType(JobPointSettings);
Builder.createAndAttachToType(JobPointSettings);
/**
 * Used for multi-staff tip splitting, tip pooling, and tip-ineligible timecards
 *
 * SOURCE TeamMemberAttributionDetails @ squareup/team_member_attribution/model.proto at 124:1
 */
export const TeamMemberAttributionDetails = {};
/**
 * SOURCE TipDistributionMethod @ squareup/team_member_attribution/model.proto at 125:3
 */
TeamMemberAttributionDetails.TipDistributionMethod = $root.lookupEnum('squareup.team_member_attribution.TeamMemberAttributionDetails.TipDistributionMethod').values;
/**
 * Used to return commission settings for a merchant
 *
 * SOURCE CommissionSettings @ squareup/team_member_attribution/model.proto at 152:1
 */
export const CommissionSettings = $root.lookupType('squareup.team_member_attribution.CommissionSettings');
fixType(CommissionSettings);
Builder.createAndAttachToType(CommissionSettings);
/**
 * SOURCE DeductFromSale @ squareup/team_member_attribution/model.proto at 166:1
 */
export const DeductFromSale = $root.lookupType('squareup.team_member_attribution.DeductFromSale');
fixType(DeductFromSale, {
  deductDiscounts: {
    required: true
  },
  deductProcessingFees: {
    required: true
  },
  deductTaxes: {
    required: true
  }
});
Builder.createAndAttachToType(DeductFromSale);
/**
 * SOURCE MerchantCommissionSettings @ squareup/team_member_attribution/model.proto at 173:1
 */
export const MerchantCommissionSettings = $root.lookupType('squareup.team_member_attribution.MerchantCommissionSettings');
fixType(MerchantCommissionSettings, {
  merchantToken: {
    required: true
  },
  itemizationItemType: {
    required: true
  },
  strategy: {
    required: true
  },
  deductDiscounts: {
    required: true
  },
  deductProcessingFees: {
    required: true
  },
  deductTaxes: {
    required: true
  }
});
Builder.createAndAttachToType(MerchantCommissionSettings);
/**
 * SOURCE ItemizationItemType @ squareup/team_member_attribution/model.proto at 174:3
 */
MerchantCommissionSettings.ItemizationItemType = $root.lookupEnum('squareup.team_member_attribution.MerchantCommissionSettings.ItemizationItemType').values;
/**
 * NONE is basically our global toggle, and can answer both "does this seller use commissions" and
 * "has this seller server used commissions?"
 * FLAT will continue to use the rates stored in employee_wage_settings
 *
 * SOURCE Strategy @ squareup/team_member_attribution/model.proto at 182:3
 */
MerchantCommissionSettings.Strategy = $root.lookupEnum('squareup.team_member_attribution.MerchantCommissionSettings.Strategy').values;
/**
 * SOURCE TierPer @ squareup/team_member_attribution/model.proto at 188:3
 */
MerchantCommissionSettings.TierPer = $root.lookupEnum('squareup.team_member_attribution.MerchantCommissionSettings.TierPer').values;
/**
 * SOURCE TierCadence @ squareup/team_member_attribution/model.proto at 193:3
 */
MerchantCommissionSettings.TierCadence = $root.lookupEnum('squareup.team_member_attribution.MerchantCommissionSettings.TierCadence').values;
/**
 * SOURCE TeamMemberCommissionSettings @ squareup/team_member_attribution/model.proto at 226:1
 */
export const TeamMemberCommissionSettings = $root.lookupType('squareup.team_member_attribution.TeamMemberCommissionSettings');
fixType(TeamMemberCommissionSettings, {
  merchantToken: {
    required: true
  },
  employeeToken: {
    required: true
  }
});
Builder.createAndAttachToType(TeamMemberCommissionSettings);
/**
 * SOURCE UnitTipDistributionSetting @ squareup/team_member_attribution/model.proto at 240:1
 */
export const UnitTipDistributionSetting = $root.lookupType('squareup.team_member_attribution.UnitTipDistributionSetting');
fixType(UnitTipDistributionSetting, {
  unitToken: {
    notEmpty: true
  },
  effectiveFrom: {
    notEmpty: true
  },
  method: {
    required: true
  }
});
Builder.createAndAttachToType(UnitTipDistributionSetting);
/**
 * SOURCE TipDistributionMethod @ squareup/team_member_attribution/model.proto at 241:3
 */
UnitTipDistributionSetting.TipDistributionMethod = $root.lookupEnum('squareup.team_member_attribution.UnitTipDistributionSetting.TipDistributionMethod').values;
/**
 * SOURCE TipDistributionSettingsUpdate @ squareup/team_member_attribution/model.proto at 266:1
 */
export const TipDistributionSettingsUpdate = $root.lookupType('squareup.team_member_attribution.TipDistributionSettingsUpdate');
fixType(TipDistributionSettingsUpdate, {
  id: {
    notEmpty: true
  },
  locationIds: {
    notEmpty: true
  },
  previousTipDistributionMethod: {
    required: true
  },
  newTipDistributionMethod: {
    required: true
  }
});
Builder.createAndAttachToType(TipDistributionSettingsUpdate);
/**
 * SOURCE TipDistributionSetting @ squareup/team_member_attribution/model.proto at 267:3
 */
TipDistributionSettingsUpdate.TipDistributionSetting = $root.lookupType('squareup.team_member_attribution.TipDistributionSettingsUpdate.TipDistributionSetting');
fixType(TipDistributionSettingsUpdate.TipDistributionSetting, {
  tipDistributionMethod: {
    required: true
  }
});
Builder.createAndAttachToType(TipDistributionSettingsUpdate.TipDistributionSetting);
/**
 * Until we add WorkweekTips, all tips will be regarded as direct tips
 *
 * SOURCE DirectTip @ squareup/team_member_attribution/model.proto at 293:1
 */
export const DirectTip = $root.lookupType('squareup.team_member_attribution.DirectTip');
fixType(DirectTip, {
  tip: {
    required: true
  },
  minute: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DirectTip);
/**
 * Some of the tips for a workweek. It is possible that the values for
 * a given workweek are split up into different paginated responses.
 *
 * SOURCE WorkweekTips @ squareup/team_member_attribution/model.proto at 308:1
 */
export const WorkweekTips = $root.lookupType('squareup.team_member_attribution.WorkweekTips');
fixType(WorkweekTips, {
  locationId: {
    notEmpty: true
  },
  workweekStart: {
    notEmpty: true
  },
  workweekEnd: {
    notEmpty: true
  },
  periodStart: {
    notEmpty: true
  },
  periodEnd: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WorkweekTips);
/**
 * SOURCE TeamMemberTip @ squareup/team_member_attribution/model.proto at 326:3
 */
WorkweekTips.TeamMemberTip = $root.lookupType('squareup.team_member_attribution.WorkweekTips.TeamMemberTip');
fixType(WorkweekTips.TeamMemberTip, {
  tip: {
    required: true
  }
});
Builder.createAndAttachToType(WorkweekTips.TeamMemberTip);
/**
 * SOURCE LaterTipRefund @ squareup/team_member_attribution/model.proto at 335:1
 */
export const LaterTipRefund = $root.lookupType('squareup.team_member_attribution.LaterTipRefund');
fixType(LaterTipRefund, {
  takenAt: {
    notEmpty: true
  },
  tip: {
    required: true
  }
});
Builder.createAndAttachToType(LaterTipRefund);
/**
 * SOURCE TipAttributionDetails @ squareup/team_member_attribution/model.proto at 347:1
 */
export const TipAttributionDetails = $root.lookupType('squareup.team_member_attribution.TipAttributionDetails');
fixType(TipAttributionDetails, {
  tipMoney: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TipAttributionDetails);